
export const AGENTES_BIWO = ["60c790904bb9710b10b079d3", "6351860084feb50016c6097f"];

export const esAgenteBiwo = (usuarioId) => AGENTES_BIWO.includes(String(usuarioId || ""));

export default esAgenteBiwo;
